// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.legend-bar {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  gap: 4px 10px;
  max-width: 68vw;
  max-height: 60px;
  overflow: hidden;
  padding: 8px 18px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 28px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}

.legend-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.legend-chip ion-icon {
  font-size: 0.95rem;
  flex-shrink: 0;
}
.legend-chip .chip-label {
  font-size: 0.62rem;
  font-weight: 500;
  color: #333;
  letter-spacing: 0.01em;
}

.legend-button-topPosition {
  font-size: 0.6rem;
  position: absolute;
  right: 10px;
  z-index: 1000;
}

.legend-card-topPosition {
  max-width: 120px;
  opacity: 0.7;
  position: absolute;
  right: 0px;
  z-index: 1000;
  border-radius: var(--border-radius-medium);
  padding: 0;
}

.legend-label {
  font-size: 0.6rem;
  margin-top: 3px;
  margin-bottom: 3px;
}

ion-card-content {
  padding: 0px;
}

ion-list {
  border-radius: var(--border-radius-medium);
  padding: 0;
}

ion-item {
  --min-height: 25px;
  --padding-start: var(--spacing-medium);
  --padding-end: var(--spacing-small);
}
ion-item::part(native) {
  --padding-start: var(--spacing-medium);
  --padding-end: var(--spacing-small);
  --inner-padding-end: var(--spacing-small);
}

ion-icon {
  font-size: 0.9rem;
  margin: 0;
  padding-left: 0;
  padding-bottom: var(--spacing-xx-small);
  padding-top: var(--spacing-xx-small);
  padding-right: var(--spacing-small);
}

/** Media queries **/
/*#region Small Screens — hide everything */
@media (max-width: 599px) {
  .legend-bar {
    display: none;
  }
  .legend-button-topPosition {
    display: none;
  }
  .legend-card-topPosition {
    display: none;
  }
}
/*#endregion*/
/*#region Medium Screens */
@media (min-width: 600px) and (max-width: 1023px) {
  .legend-button-topPosition {
    top: 100px;
  }
  .legend-card-topPosition {
    top: 120px;
    max-width: 120px;
  }
  .legend-bar {
    left: calc(50% + 60px);
  }
}
/*#endregion*/
/*#region Large Screens */
@media (min-width: 1024px) {
  .legend-button-topPosition {
    top: 110px;
  }
  .legend-card-topPosition {
    top: 130px;
  }
  .legend-bar {
    max-width: 60vw;
    max-height: 64px;
    gap: 5px 14px;
    padding: 9px 22px;
    left: calc(50% + 80px);
  }
  .legend-chip ion-icon {
    font-size: 1.1rem;
  }
  .legend-chip .chip-label {
    font-size: 0.68rem;
  }
  ion-icon {
    font-size: 1.2rem;
  }
  .legend-label {
    font-size: 0.7rem;
  }
}
/*#endregion*/`, "",{"version":3,"sources":["webpack://./src/app/components/check-near-infrastructures/color-legend/color-legend.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAIhB;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EAGA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EAEA,eAAA;EAEA,gBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,mBAAA;EACA,0CAAA;EACA,oBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAPF;AASE;EACE,kBAAA;EACA,cAAA;AAPJ;AAUE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AARJ;;AAgBA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,0CAAA;EACA,UAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,YAAA;AAbF;;AAgBA;EACE,0CAAA;EACA,UAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,sCAAA;EACA,mCAAA;AAbF;AAcE;EACE,sCAAA;EACA,mCAAA;EACA,yCAAA;AAZJ;;AAgBA;EACE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,uCAAA;EACA,oCAAA;EACA,mCAAA;AAbF;;AAgBA,oBAAA;AAEA,2CAAA;AACA;EACE;IACE,aAAA;EAdF;EAiBA;IACE,aAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;AACF;AAkBA,aAAA;AAEA,0BAAA;AACA;EACE;IACE,UAAA;EAjBF;EAoBA;IACE,UAAA;IACA,gBAAA;EAlBF;EAsBA;IACE,sBAAA;EApBF;AACF;AAsBA,aAAA;AAEA,yBAAA;AACA;EACE;IACE,UAAA;EArBF;EAwBA;IACE,UAAA;EAtBF;EAyBA;IACE,eAAA;IACA,gBAAA;IACA,aAAA;IACA,iBAAA;IACA,sBAAA;EAvBF;EA2BE;IACE,iBAAA;EAzBJ;EA4BE;IACE,kBAAA;EA1BJ;EA8BA;IACE,iBAAA;EA5BF;EA+BA;IACE,iBAAA;EA7BF;AACF;AA+BA,aAAA","sourcesContent":["// ─────────────────────────────────────────────────────────────────────────────\r\n// Bottom-position: horizontal pill bar, centred at the bottom of the viewport\r\n// ─────────────────────────────────────────────────────────────────────────────\r\n\r\n.legend-bar {\r\n  position: fixed;\r\n  bottom: 16px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 1000;\r\n\r\n  // Horizontal, wrapping into at most 2 rows\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-content: center;\r\n  gap: 4px 10px;\r\n  // Limit width so items wrap into 2 rows for 6+ types\r\n  max-width: 68vw;\r\n  // Allow at most 2-row height (each row ~26 px + 4 px gap)\r\n  max-height: 60px;\r\n  overflow: hidden;\r\n\r\n  padding: 8px 18px;\r\n  background: rgba(255, 255, 255, 0.88);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 28px;\r\n  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.15);\r\n  pointer-events: none;\r\n}\r\n\r\n.legend-chip {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  white-space: nowrap;\r\n\r\n  ion-icon {\r\n    font-size: 0.95rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .chip-label {\r\n    font-size: 0.62rem;\r\n    font-weight: 500;\r\n    color: #333;\r\n    letter-spacing: 0.01em;\r\n  }\r\n}\r\n\r\n// ─────────────────────────────────────────────────────────────────────────────\r\n// Top-position: toggle button + vertical card (existing behaviour)\r\n// ─────────────────────────────────────────────────────────────────────────────\r\n\r\n.legend-button-topPosition {\r\n  font-size: 0.6rem;\r\n  position: absolute;\r\n  right: 10px;\r\n  z-index: 1000;\r\n}\r\n\r\n.legend-card-topPosition {\r\n  max-width: 120px;\r\n  opacity: 0.7;\r\n  position: absolute;\r\n  right: 0px;\r\n  z-index: 1000;\r\n  border-radius: var(--border-radius-medium);\r\n  padding: 0;\r\n}\r\n\r\n.legend-label {\r\n  font-size: 0.6rem;\r\n  margin-top: 3px;\r\n  margin-bottom: 3px;\r\n}\r\n\r\nion-card-content {\r\n  padding: 0px;\r\n}\r\n\r\nion-list {\r\n  border-radius: var(--border-radius-medium);\r\n  padding: 0;\r\n}\r\n\r\nion-item {\r\n  --min-height: 25px;\r\n  --padding-start: var(--spacing-medium);\r\n  --padding-end: var(--spacing-small);\r\n  &::part(native) {\r\n    --padding-start: var(--spacing-medium);\r\n    --padding-end: var(--spacing-small);\r\n    --inner-padding-end: var(--spacing-small);\r\n  }\r\n}\r\n\r\nion-icon {\r\n  font-size: 0.9rem;\r\n  margin: 0;\r\n  padding-left: 0;\r\n  padding-bottom: var(--spacing-xx-small);\r\n  padding-top: var(--spacing-xx-small);\r\n  padding-right: var(--spacing-small);\r\n}\r\n\r\n/** Media queries **/\r\n\r\n/*#region Small Screens — hide everything */\r\n@media (max-width: 599px) {\r\n  .legend-bar {\r\n    display: none;\r\n  }\r\n\r\n  .legend-button-topPosition {\r\n    display: none;\r\n  }\r\n\r\n  .legend-card-topPosition {\r\n    display: none;\r\n  }\r\n}\r\n/*#endregion*/\r\n\r\n/*#region Medium Screens */\r\n@media (min-width: 600px) and (max-width: 1023px) {\r\n  .legend-button-topPosition {\r\n    top: 100px;\r\n  }\r\n\r\n  .legend-card-topPosition {\r\n    top: 120px;\r\n    max-width: 120px;\r\n  }\r\n\r\n  // Shift pill right of centre so it doesn't overlap the hover panel on the left.\r\n  .legend-bar {\r\n    left: calc(50% + 60px);\r\n  }\r\n}\r\n/*#endregion*/\r\n\r\n/*#region Large Screens */\r\n@media (min-width: 1024px) {\r\n  .legend-button-topPosition {\r\n    top: 110px;\r\n  }\r\n\r\n  .legend-card-topPosition {\r\n    top: 130px;\r\n  }\r\n\r\n  .legend-bar {\r\n    max-width: 60vw;\r\n    max-height: 64px;\r\n    gap: 5px 14px;\r\n    padding: 9px 22px;\r\n    left: calc(50% + 80px); // extra nudge right to clear wider hover panel\r\n  }\r\n\r\n  .legend-chip {\r\n    ion-icon {\r\n      font-size: 1.1rem;\r\n    }\r\n\r\n    .chip-label {\r\n      font-size: 0.68rem;\r\n    }\r\n  }\r\n\r\n  ion-icon {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .legend-label {\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n/*#endregion*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
